import { c as _c } from "react/compiler-runtime";
import React, { ReactNode } from 'react';
import { mergeClasses } from '@/utils/style';
type InsuranceCategoryButtonProps = {
  icon: ReactNode;
  label: string;
  checked: boolean;
  onChange: () => void;
  containerRef?: (node: HTMLDivElement | null) => void;
};
export function InsuranceCategoryButton(t0) {
  const $ = _c(17);
  const {
    icon,
    label,
    checked,
    onChange,
    containerRef
  } = t0;
  const t1 = checked ? 0 : -1;
  let t2;
  if ($[0] !== onChange) {
    t2 = event => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        onChange();
      }
    };
    $[0] = onChange;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = checked ? "border-blue-500" : "border-transparent bg-blue-50 hover:border-blue-300";
  let t4;
  if ($[2] !== t3) {
    t4 = mergeClasses("flex h-40 w-35 shrink-0 cursor-pointer flex-col items-center justify-center gap-2 rounded-xl border bg-white p-2 text-center transition-colors focus-visible:ring-3 focus-visible:outline-blue-500 focus-visible:outline-dotted md:h-20 md:w-auto md:flex-row md:items-center md:justify-start md:p-4 md:text-left", t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== icon) {
    t5 = <span className="flex shrink-0 items-center justify-center text-blue-500">{icon}</span>;
    $[4] = icon;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== label) {
    t6 = <span className="text-center text-sm font-semibold text-gray-900 md:text-left md:text-base">{label}</span>;
    $[6] = label;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== checked || $[9] !== containerRef || $[10] !== onChange || $[11] !== t1 || $[12] !== t2 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <div ref={containerRef} role="radio" aria-checked={checked} tabIndex={t1} onClick={onChange} onKeyDown={t2} className={t4}>{t5}{t6}</div>;
    $[8] = checked;
    $[9] = containerRef;
    $[10] = onChange;
    $[11] = t1;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}